import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDashed } from '@fortawesome/pro-regular-svg-icons/faCircleDashed';

import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button } from 'ui-components/components/button';
import { goToOrderDetails } from '../../../../../store/orders/order-details/orders.details.actions';
import { useSalesOrderIdContext } from '../../../../../orders/context/sales-order-id-context-provider';
import { useShipmentsPanelContext } from '../../../side-panel/shipments/shipments-panel-context-provider';
import { FulfillmentPlanOrderGridStatus } from '../../../../../enums/fulfillmentplan-order-grid-status';
import style from './style.module.less';
import { messages } from './messages';
import { StatusConnector } from './status-connector';
import { RateCard } from './rate-card';

export const SectionContent = () => {
  const dispatch = useDispatch();
  const sidePanelFulfillmentPlans = useShipmentsPanelContext();
  const salesOrderId = useSalesOrderIdContext();

  const navigateToFulfillmentPlan = useCallback(
    (fulfillmentPlanId) => {
      dispatch(
        goToOrderDetails({
          salesOrderId,
          fulfillmentPlanId,
          selectOrderInGrid: true,
        }),
      );
    },
    [dispatch, salesOrderId],
  );
  return (
    <div>
      {sidePanelFulfillmentPlans.map(({ counter, fulfillmentPlanId, orderGridStatus }) => (
        <div key={fulfillmentPlanId} className={style['label-history-item']}>
          <div className={style['label-history-item-head']}>
            <div>
              <FontAwesomeIcon className={style.icon} icon={faCircleDashed} />
            </div>
            <div>
              <FormattedMessage
                {...messages.shipmentLinkText}
                values={{
                  counter,
                  b: () => <FormattedMessage {...FulfillmentPlanOrderGridStatus[orderGridStatus].translation} />,
                  a: (chunks) => (
                    <Button className={style['link-button']} onClick={() => navigateToFulfillmentPlan(fulfillmentPlanId)} theme='link'>
                      {chunks}
                    </Button>
                  ),
                }}
              />
            </div>
          </div>
          <div className={style['label-history-item-content']}>
            <StatusConnector />
            <RateCard fulfillmentPlanId={fulfillmentPlanId} />
          </div>
        </div>
      ))}
    </div>
  );
};
